export default {
    name: 'c-no-data',
    data() {

    },
    components: {

    },
    created() {

    },
    watch: {
    },
    computed: {
    },
    methods: {
    }
}